import {
  keepPreviousData,
  queryOptions,
  skipToken,
} from '@tanstack/react-query';

import type {
  InventoryProductCategoriesQueryParams,
  InventoryProductCategoriesResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const inventoryProductCategoryKeys = {
  all: () => ['inventoryProductCategories'] as const,
  tree: (props: InventoryProductCategoriesQueryParams) =>
    [
      ...inventoryProductCategoryKeys.all(),
      'tree',
      props.url,
      props.filters,
    ] as const,
};

export const inventoryProductCategoryQueries = {
  tree: (props: InventoryProductCategoriesQueryParams) =>
    queryOptions({
      queryKey: inventoryProductCategoryKeys.tree(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<InventoryProductCategoriesResponseData>({
              method: 'GET',
              url: props.url,
              params: props.filters ? { filters: props.filters } : undefined,
            })
        : skipToken,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),
};
